(function () {
  const SUCCESS_PATTERN = /登録完了|ありがとうございます/;

  function resolveModal(node) {
    if (!node || node.nodeType !== 1) return null;
    if (node.classList?.contains('ngc__modal')) return node;
    if (node.id === 'ngc-restock') return node.querySelector('.ngc__modal');
    return node.closest?.('.ngc__modal') || node.querySelector?.('.ngc__modal');
  }

  function isEmailStepVisible(modal) {
    const emailInput = modal.querySelector('input[type="email"]');
    if (!emailInput) return false;
    return emailInput.offsetParent !== null && !emailInput.closest('[hidden]');
  }

  function isSuccessState(modal) {
    if (!modal || !SUCCESS_PATTERN.test(modal.textContent || '')) return false;
    return !isEmailStepVisible(modal);
  }

  function enhanceModal(modal) {
    if (!modal || !isSuccessState(modal)) return;
    if (modal.classList.contains('yamaga-ngc-modal--success')) return;

    modal.classList.add('yamaga-ngc-modal--success');
    modal.setAttribute('role', 'alertdialog');
    modal.setAttribute('aria-live', 'assertive');

    const information = modal.querySelector(
      '.ngc__modal__information, [class*="modal__information"], [class*="success"]'
    );
    if (information) {
      information.classList.add('yamaga-ngc-success-message');
    }

    window.requestAnimationFrame(function () {
      modal.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  }

  function scan(root) {
    const scope = root && root.nodeType === 1 ? root : document;
    scope.querySelectorAll('.ngc__modal, #ngc-restock').forEach(function (node) {
      enhanceModal(resolveModal(node));
    });
  }

  scan();

  new MutationObserver(function () {
    scan();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden'],
  });
})();
